import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import CrissleCrossleImg from 'assets/crisslecrossle.png';
import Word500Img from 'assets/word500.png';
import SedecordleImg from 'assets/sedecordle.png';
import SedecorderImg from 'assets/sedec-order.png';
import SaviorImg from 'assets/savior.png';
import SedecordlePracticeImg from 'assets/sedecordle-practice.png';
import SedecorderPracticeImg from 'assets/sedec-order-practice.png';
import SaviorPracticeImg from 'assets/savior-practice.png';
import { ReactComponent as ArrowRightUpSvg } from 'assets/arrow-right-up.svg';
import RadioGroup from 'elements/RadioGroup';
import Switch from 'elements/Switch';

import Header from './Header';
import Footer from './Footer';

interface IOption {
  value: string
  label: string
  image?: string
  practiceImage?: string
};

const modes: IOption[] = [
  { value: 'daily', label: 'Daily' },
  { value: 'practice', label: 'Practice' },
];
const types: IOption[] = [
  {
    value: 'sedecordle',
    label: 'Sedecordle',
    image: SedecordleImg,
    practiceImage: SedecordlePracticeImg
  },
  {
    value: 'sedec-order',
    label: 'Sedec-order',
    image: SedecorderImg,
    practiceImage: SedecorderPracticeImg
  },
  {
    value: 'savior',
    label: 'Savior',
    image: SaviorImg,
    practiceImage: SaviorPracticeImg
  },
];

interface IGame {
  title: string
  link: string
  image?: string
};

const moreGames: IGame[] = [
  { title: 'Crissle Crossle', link: 'https://crisslecrossle.com', image: CrissleCrossleImg },
  { title: 'Word 500', link: 'https://word500.com', image: Word500Img }
];

const Home = () => {
  const navigate = useNavigate();
  const [mode, setMode] = useState<IOption>(modes[0]);
  const [type, setType] = useState<IOption>(types[0]);

  useEffect(() => {
    const [modeValue, typeValue] = (localStorage.getItem('mode-type') || '').split(',');
    if (modeValue) {
      setMode(modes.find(({ value }) => value === modeValue) || modes[0]);
    }
    if (typeValue) {
      setType(types.find(({ value }) => value === typeValue) || types[0]);
    }
  }, [])

  useEffect(() => {
    localStorage.setItem('mode-type', `${mode.value},${type.value}`);
  }, [mode, type])

  const loadGame = (length = 5) => {
    
    if (type.value === 'sedecordle') {
      const lengthString = length === 5 ? '' : `&length=${length}`;
      // navigate(`/?mode=${mode.value === 'daily' ? 'daily' : 'free'}${lengthString}`);
      window.location.href = `/?mode=${mode.value === 'daily' ? 'daily' : 'free'}${lengthString}`
    } else {
      const lengthString = length === 5 ? '' : `?length=${length}`;
      if (mode.value === 'daily') {
        // navigate(`/${type.value}${lengthString}`);
        window.location.href = `/${type.value}${lengthString}`
      } else {
        // navigate(`/${type.value}/practice${lengthString}`);
        window.location.href = `/${type.value}/practice${lengthString}`
      }
    }
  }

  return (
    <div className="bg-[#0B0D12] relative overflow-hidden">
      <Header />
      <div
        className="h-[800px] absolute top-[120px] -right-[170px] md:block hidden"
      />
      <div
        className="w-[700px] h-[700px] absolute top-[320px] -left-[300px] md:block hidden"
      />
      <div
        className="w-full"
      >
        <div className="max-w-[550px] w-full px-6 py-10 m-auto flex flex-col items-center gap-3">
          <Switch
            options={modes}
            value={mode}
            onChange={setMode}
          />
          {mode.value !== 'multi-player' && (
            <RadioGroup
              options={types}
              value={type}
              onChange={setType}
            />
          )}
          {/* <div
            className="w-full p-4 mt-2 border border-solid rounded-lg cursor-pointer flex flex-col items-start gap-2 relative"
            style={{
              background: 'linear-gradient(141deg, rgba(8, 134, 92, 0.29) 0%, rgba(21, 24, 32, 0.60) 100%, rgba(18, 134, 8, 0.01) 100%)',
              borderColor: 'rgba(0, 204, 136, 0.20)'
            }}
            onClick={() => loadGame()}
          >
            <img
              className="absolute right-0 top-0 h-[100%]"
              src={mode.value === 'daily' ? type.image : type.practiceImage}
              alt=""
            />
            <div className="text-[#D0D0D0] text-sm relative">Game selected</div>
            <div className="text-white text-lg font-semibold relative">{mode.label} {type.label} Classic</div>
            <div className="bg-[#08865C] w-[150px] h-[40px] rounded text-sm font-semibold flex items-center justify-center mt-3 relative">Play Now</div>
          </div> */}
          <div className="text-lg mt-6">{mode.label} {type.label} Variations</div>
          <div className="bg-[#151820] px-3 w-full rounded-lg border border-[#282828] border-solid">
            {new Array(8).fill(0).map((m, index) => {
              if (index === 1) {
                return null;
              }
              return (
                <div className={classNames("flex items-center justify-between py-3", { 'border-0 border-t border-[#282828] border-solid': index !== 0 })} key={index}>
                  <div className="text-sm">{mode.label} {index + 4} Letter {type.label}</div>
                  <div
                    className="border border-solid text-sm flex rounded items-center justify-center w-[100px] h-[36px] cursor-pointer hover:bg-[#08865C] transition-all"
                    onClick={() => loadGame(index + 4)}
                    style={{ borderColor: 'rgba(0, 204, 136, 0.5)' }}
                  >
                    Play
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-lg mt-3">More Word Games</div>
          <div className="flex items-center w-full gap-3 mt-2 flex-wrap justify-center">
            {moreGames.map(({ title, link, image }: IGame) => (
              <div key={link} className="flex-1 bg-[#232323] rounded-lg overflow-hidden p-3 flex flex-col gap-2 items-center min-w-[180px] max-w-[220px]">
                <img src={image} alt={title} className="w-full" />
                <div className="text-base font-semibold">{title}</div>
                <div
                  className="border-2 border-solid text-sm flex rounded items-center justify-between w-[100px] h-[36px] cursor-pointer hover:bg-[#08865C] transition-all p-2 text-xs w-full"
                  onClick={() => window.open(link, '_blank')}
                  style={{ borderColor: 'rgba(0, 204, 136, 0.5)' }}
                >
                  Play {title}
                  <ArrowRightUpSvg height="20px" />
                </div>
              </div>
            ))}
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Home;